import { MapPin, Loader2, AlertCircle } from "lucide-react";
import type { GeoCoordinates } from "@/types/location";

interface Props {
  coords: GeoCoordinates | null;
  status: string;
  error: string | null;
}

export function LocationStatus({ coords, status, error }: Props) {
  if (status === "requesting") {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Loader2 className="size-4 animate-spin" />
        <span>Detecting location...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-1">
        <div className="flex items-center gap-2 text-sm text-destructive">
          <AlertCircle className="size-4" />
          <span>Location unavailable</span>
        </div>
        <p className="text-xs text-muted-foreground pl-6">
          Open settings to search for your city
        </p>
      </div>
    );
  }

  if (coords) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <MapPin className="size-4" />
        <span>
          {coords.name ?? `${coords.latitude.toFixed(2)}, ${coords.longitude.toFixed(2)}`}
        </span>
      </div>
    );
  }

  return null;
}
